import React from 'react';
import { FACESHEET_LAYOUT, PURPOSE, NOTICE } from '../../utils/facesheetLayout';

const cellBase = 'border border-[#6077c8] px-1.5 pt-0.5 pb-1 min-w-0';
const inputBase = 'w-full bg-[#dbeafe] text-[#14145a] text-[13px] px-1 py-0.5 outline-none focus:bg-white focus:ring-1 focus:ring-[#1e40af] font-sans';

const Options = ({ opts, value, onPick, k }) => (
  <div className="flex flex-wrap gap-x-1.5 gap-y-0.5 text-[11.5px] font-serif">
    {opts.map(op => {
      const on = (value || '').toLowerCase() === op.toLowerCase();
      return (
        <button type="button" key={op} onClick={() => onPick(on ? '' : op)} data-testid={`fs-${k}-${op.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
          className={`whitespace-nowrap ${on ? 'text-[#1e40af] font-bold' : 'text-gray-800'} hover:text-[#1e40af]`}>
          ({on ? 'X' : '\u00a0'}){op}
        </button>
      );
    })}
  </div>
);

const Cell = ({ c, v, set }) => {
  const bind = (k) => ({ value: v[k] ?? '', onChange: (e) => set(k, e.target.value), 'data-testid': `fs-${k}`, name: k });
  let body;
  if (c.opts) body = <Options opts={c.opts} value={v[c.k]} onPick={(x) => set(c.k, x)} k={c.k} />;
  else if (c.keys) body = <div className="flex gap-1">{c.keys.map((k, i) => <input key={k} className={inputBase} style={{ width: i ? '58%' : '42%' }} {...bind(k)} />)}</div>;
  else if (c.area) body = <textarea rows={c.area} className={`${inputBase} resize-y`} {...bind(c.k)} />;
  else body = <input type={c.date ? 'date' : 'text'} readOnly={c.readOnly} className={inputBase} {...bind(c.k)} />;
  return (
    <div className={cellBase} style={{ flex: `${c.s} 1 0` }}>
      {c.l && <div className="text-[12px] font-serif text-black leading-tight mb-0.5">{c.l}</div>}
      {body}
    </div>
  );
};

const Section = ({ sec, v, set }) => (
  <>
    <div className="bg-[#1e40af] text-white font-serif font-bold text-[13px] px-2 py-1 flex flex-wrap gap-x-10">
      <span>{sec.title}</span>
      {sec.secondary && (
        <span className="font-normal">
          ({v.secondaryInsuranceName ? '\u00a0' : 'X'})None-Go to Section 5 &nbsp;&nbsp; ({v.secondaryInsuranceName ? 'X' : '\u00a0'})Yes - Complete Section 4
        </span>
      )}
    </div>
    {sec.rows.map((row, i) => (
      <div key={i} className="flex flex-col sm:flex-row">{row.map(c => <Cell key={c.k || c.keys.join()} c={c} v={v} set={set} />)}</div>
    ))}
  </>
);

// Paper-style Face Sheet that mirrors the downloaded PDF
export const FaceSheetForm = ({ values, onChange, header }) => (
  <div className="bg-white shadow-lg mx-auto max-w-[1000px] p-4 sm:p-6" data-testid="facesheet-sheet">
    {header}
    <div className="border-[3px] border-[#1e40af]">
      {FACESHEET_LAYOUT.map(sec => <Section key={sec.title} sec={sec} v={values} set={onChange} />)}
      <div className={`${cellBase} text-[12px] font-serif`}><b>Purpose of disclosure:</b> {PURPOSE}</div>
      <div className={`${cellBase} text-[12px] font-serif font-bold`}>{NOTICE}</div>
    </div>
    <div className="flex justify-between items-end mt-2 font-serif text-[12px]">
      <div><div>IVORY Home Health Care</div><div className="text-[#1e40af] font-bold text-[15px]">FACE SHEET</div></div>
      <div className="text-[14px]">PATIENT LABEL</div>
    </div>
  </div>
);
